import { Navbar } from 'react-bootstrap';
import logo from 'assets/logo.png';
import './style.ts';
import * as SC from './style';

const Header = () => {
  return (
    <SC.headlineContainer>
      <Navbar bg="transparent" variant="dark">
        <Navbar.Brand onClick={() => scrollTo(0, 0)}>
          <div className="logo-container">{<img src={logo} alt="" />}</div>
        </Navbar.Brand>
        {/* <Nav className="mr-auto">
          <Nav.Link key="enroll" onClick={enrollSection.onClick}>
            ANMELDEN
          </Nav.Link>
          <Nav.Link key="impressum" href="/impressum">
            IMPRESSUM
          </Nav.Link>
        </Nav> */}
      </Navbar>
    </SC.headlineContainer>
  );
};

export default Header;
